module.exports = __webpack_public_path__ + "f761de500ee57300ce211cc90e83ed1f.MP3";